import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg style={{ display: "block" }} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>0: Icons / Expand</title>
    <g id="0:-Icons-/-Expand" stroke="none" strokeWidth="1">
        <path d="M3,3 L10,3 L10,5.2 L5.2,5.2 L5.2,10 L3,10 L3,3 Z" id="TopLeft"></path>
        <path d="M14,3 L21,3 L21,10 L18.8,10 L18.8,5.2 L14,5.2 L14,3 Z" id="TopRight"></path>
        <path d="M3,14 L5.2,14 L5.2,18.8 L10,18.8 L10,21 L3,21 L3,14 Z" id="BottomLeft"></path>
        <path d="M18.8,14 L21,14 L21,21 L14,21 L14,18.8 L18.8,18.8 L18.8,14 Z" id="BottomRight"></path>
    </g>
</svg>;
